import React, { useState } from "react";
import { GiPartyPopper } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";
import "./trivia.css";
import "animate.css";
import useAuth from "../../../hooks/useAuth";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Correct = ({ number, handleClose, length }) => {
  const [size, setSize] = useState(0);
  const { getUserId } = useAuth();
  const navigate = useNavigate();

  const getSize = (url) => {
    const img = new Image();
    img.onload = () => {
      setSize(img.width / img.height);
    };
    img.src = url;
  };

  const Imagen = () => {
    getSize(`../../../images/${number}.jpg`);
    if (size > 1) {
      return (
        <img
          className="win-card animate__animated animate__tada"
          src={`../../../images/${number}.jpg`}
          alt="imagen"
          width="450vw"
        />
      );
    } else {
      return (
        <img
          className="win-card animate__animated animate__tada"
          src={`../../../images/${number}.jpg`}
          alt="imagen"
          height="350vh"
        />
      );
    }
  };

  const deleteAlbum = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const userId = getUserId();
    axios
      .delete(`${apiUrl}/questions/${userId}`)
      .then(() => {
        toast.success("Álbum reiniciado correctamente", {
          style: {
            fontFamily: "Noto Sans",
            fontSize: "16px",
            textAlign: "left",
          },
        });
        navigate("/album");
      })
      .catch(() => {
        toast.error("Oops, hubo un problema al reiniciar el álbum", {
          style: {
            fontFamily: "Noto Sans",
            fontSize: "16px",
            textAlign: "left",
          },
        });
      });
  };

  const currentPage = Math.ceil(number / 5);
  const bgMappings = {
    1: 1,
    2: 1,
    3: 2,
    4: 2,
    5: 3,
    6: 3,
    7: 4,
    8: 4,
  };
  const bg = bgMappings[currentPage];

  return (
    <div className="win">
      {Imagen(number)}
      <div>
        <img src="../../../images/happy.svg" alt="Cara feliz" width="50" />
      </div>
      <p>
        <GiPartyPopper /> ¡Felicitaciones! Ganaste la figurita número {number}
      </p>
      <p> {length === 39 ? "y completaste el álbum" : ""}</p>
      <div>
        {length === 39 ? (
          <button
            className="button button-incorrect"
            onClick={() => {
              deleteAlbum();
            }}
          >
            Reiniciar Álbum
          </button>
        ) : (
          <button className="button button-primary" onClick={handleClose}>
            ¡Seguir jugando!
          </button>
        )}

        <Link to="/album" state={{ page: currentPage, bg: bg, }}>
          <button className="button button-secondary">Ir al Álbum</button>
        </Link>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default Correct;
